import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, ShoppingBag, Download } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { api, brl, formatErr } from "../lib/api";

export const ShopeeSearch = ({ onImported }) => {
  const [open, setOpen] = useState(false);
  const [kw, setKw] = useState("");
  const [busy, setBusy] = useState(false);
  const [items, setItems] = useState([]);
  const [err, setErr] = useState("");

  const search = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try { const { data } = await api.post("/integrations/shopee/search", { keyword: kw }); setItems(data.nodes || []); }
    catch (e2) { setErr(formatErr(e2)); } finally { setBusy(false); }
  };

  const importItem = async (it) => {
    try {
      await api.post("/products", {
        title: it.productName, url: it.offerLink || it.productLink || "", price_to: it.priceMin ? Number(it.priceMin) : null,
        commission_pct: it.commissionRate ? Math.round(Number(it.commissionRate) * 10000) / 100 : null, image_url: it.imageUrl || "", niche: "Outros", notes: it.shopName ? `Loja: ${it.shopName}` : "",
      });
      toast.success("Produto importado!");
      onImported();
    } catch (e) { toast.error(formatErr(e)); }
  };

  return (
    <>
      <Button variant="outline" className="rounded-full h-11 border-[#EE4D2D]/50 text-[#ff7a5c] hover:bg-[#EE4D2D]/10" onClick={() => setOpen(true)} data-testid="shopee-search-open-button"><ShoppingBag className="h-4 w-4 mr-1" />Shopee</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-zinc-950 border-zinc-800 text-white max-h-[90vh] overflow-y-auto sm:max-w-2xl" data-testid="shopee-search-dialog">
          <DialogHeader><DialogTitle className="font-display">Buscar ofertas na Shopee Afiliados</DialogTitle></DialogHeader>
          <form onSubmit={search} className="flex gap-2">
            <Input value={kw} onChange={(e) => setKw(e.target.value)} placeholder="Ex.: fone bluetooth" className="bg-zinc-900 border-zinc-800" required minLength={2} data-testid="shopee-search-input" />
            <Button type="submit" className="btn-gold rounded-full" disabled={busy} data-testid="shopee-search-submit">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Buscar"}</Button>
          </form>
          {err && <div className="text-sm text-rose-400" data-testid="shopee-search-error">{err} {err.includes("Configure") && <Link to="/integracoes" className="text-amber-400 underline">Ir para Integrações</Link>}</div>}
          <div className="grid gap-2">
            {items.map((it) => (
              <div key={it.itemId} className="flex gap-3 items-center card-lux p-2">
                {it.imageUrl && <img src={it.imageUrl} alt="" className="h-14 w-14 rounded-lg object-cover" />}
                <div className="flex-1 min-w-0"><div className="text-sm truncate">{it.productName}</div><div className="text-xs text-zinc-400">{brl(it.priceMin)} • comissão {(Number(it.commissionRate) * 100).toFixed(1)}%</div></div>
                <Button size="sm" variant="outline" className="rounded-full border-zinc-700" onClick={() => importItem(it)}><Download className="h-3.5 w-3.5" /></Button>
              </div>
            ))}
          </div>
          <p className="text-[11px] text-zinc-500">Dados obtidos pela Shopee Affiliate Open API oficial com suas credenciais.</p>
        </DialogContent>
      </Dialog>
    </>
  );
};
